module.exports = __webpack_public_path__ + "static/footer-bear@2x-80fa0f1d0721ae99ff508b32dfb7f2cb.png";